﻿import { parseDecimal, formatDecimal, formatDefault }
    from '../js/modules/utils/format';
import { ppUtils } from '../js/modules/utils/utils';
import { ppUI } from '../js/modules/utils/ui';
import { toolbar } from '../js/modules/utils/toolbar';
import { modal } from '../js/modules/utils/modal';
import { dropzone } from '../js/modules/utils/dropzone';
import { Convert } from '../js/modules/utils/convert';
import { Alert } from '../js/modules/utils/alert';
import { Watcher } from '../js/modules/utils/watcher';
import { Command } from '../js/modules/utils/command';
import { Polling } from '../js/modules/utils/polling';
import { toast } from '../js/modules/utils/toast';

export default function(){
    window.parseDecimal = parseDecimal;
    window.formatDecimal = formatDecimal;
    window.formatDefault = formatDefault;
    window.ppUtils = ppUtils;
    window.ppUI = ppUI;
    window.toolbar = toolbar;
    window.modal = modal;
    window.dropzone = dropzone;
    window.Convert = Convert;
    window.Alert = Alert;
    window.Watcher = Watcher;
    window.Command = Command;
    window.Polling = Polling;
    window.toast = toast;
}